"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAnnuityPaymentOptions = void 0;
const common_1 = require("../../common");
const common_2 = require("../common");
const annuity_options_validator_1 = require("./annuity-options-validator");
function createAnnuityPaymentOption(options) {
    const premium = common_2.roundPayment(options.amount / options.numberOfPayments);
    return {
        amountOfFirstPayment: premium,
        paymentPeriod: null,
        paymentMode: common_1.PaymentMode.Multi,
        premium,
        numberOfPayments: options.numberOfPayments,
        faceAmount: options.amount,
        years: 0,
    };
}
function calculateAnnuityPaymentOptions(options) {
    const validation = annuity_options_validator_1.validateAnnuityOptions(options);
    if (!validation.isValid) {
        return Object.assign(Object.assign({}, validation), { paymentOptions: [] });
    }
    return {
        isValid: true,
        errors: [],
        paymentOptions: [createAnnuityPaymentOption(options)],
    };
}
exports.calculateAnnuityPaymentOptions = calculateAnnuityPaymentOptions;
//# sourceMappingURL=annuity-payment-calculator.js.map